import classNames from 'classnames';

import ModalPortal from 'src/shared/react-utils/ModalPortal';
import { AuthEntity } from 'src/store/auth/auth';

import { Avatar, Button, XIcon } from 'fasoo-ui-component-next';
import { CommonProps } from 'fasoo-ui-component-next/dist/src/components/helpers/props';

import './index.scss';
import { useNavigate } from 'react-router-dom';
import config from 'src/shared/config';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePreventScrollStore from 'src/hooks/usePreventScroll';

export interface UserStatusPopupProps extends CommonProps {
  open: boolean;
  onClose: () => void;
  width?: string;
  title: string;
  authEntity: AuthEntity | undefined;
  handleLogOut: () => void;
}

const UserStatusPopup: React.FC<UserStatusPopupProps> = ({
  open,
  onClose,
  width = '100%',
  title,
  authEntity,
  handleLogOut,
  classes,
}) => {
  const { t } = useTranslation(['userStatus']);
  const [isEnter, setIsEnter] = useState<boolean>(false);
  const navigate = useNavigate();
  const { startPreventScroll, stopPreventScroll } = usePreventScrollStore();
  const handleGoSignIn = (): void => {
    navigate(config.url('/sign-in'));
  };
  const handleSignOut = (): void => {
    handleLogOut();
    onClose();
  };
  useEffect(() => {
    if (isEnter === false) {
      startPreventScroll();
      setIsEnter(true);
    }
    return () => {
      stopPreventScroll();
    };
  }, []);
  return (
    <ModalPortal>
      <div className={classNames('user-status-popup', { on: open }, classes)}>
        <div className="user-stauts-popup-container" style={{ width: `${width}` }}>
          <div className="user-status-popup-head">
            <div className="header-left-container">dfdadsf</div>

            <div className="header-title-text-container">
              <p className="header-title-text">{title}</p>
            </div>

            <div className="icon-container" onClick={onClose}>
              {/* <IconButton onClick={onClose}> */}
              <XIcon color={'white'} />
              {/* </IconButton> */}
            </div>
          </div>
          <div className="user-status-divider"></div>
          <div className="user-status-popup-body">
            {authEntity !== undefined ? (
              <div className="user-status-popup-items">
                <Avatar variant="self" size="xl" />
                <div className="user-status-popup-item-title">
                  {authEntity.tokenEntity.userInfo.userName +
                    ` (${authEntity.tokenEntity.userInfo.userId})`}
                </div>
                <div className="user-status-popup-item-desc">
                  {authEntity.tokenEntity.userInfo.positionName +
                    ' / ' +
                    authEntity.tokenEntity.userInfo.deptName}
                </div>
              </div>
            ) : (
              <div className="user-status-popup-items">
                <Avatar onlineStatus={false} variant="self" size="xl" />
                <div className="user-status-popup-item-title">
                  {t('userStatus:logout.description')}
                </div>
                <div className="user-status-popup-item-desc">{t('userStatus:logout:help')}</div>
              </div>
            )}
          </div>
          <div className="user-status-popup-foot">
            {authEntity !== undefined ? (
              <Button
                height={52}
                fullWidth={true}
                text={t('userStatus:logout.$')}
                onClick={() => handleSignOut()}
              />
            ) : (
              <div className="user-status-popup-foot-need-login">
                <Button
                  height={52}
                  color="default"
                  classes="icon-next-time"
                  text={t('userStatus:notNow')}
                  onClick={onClose}
                />
                <Button
                  height={52}
                  classes="icon-login-start"
                  text={t('userStatus:startLogin')}
                  onClick={() => handleGoSignIn()}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default UserStatusPopup;
